import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Swal from 'sweetalert2';
import gql from 'graphql-tag';
import Loader from '../../components/CustomLoader';
import client from '../../utils/apolloClient';
import { getUser } from '../../data-services/queries';
import { listCmdiForAmmd } from './ettcSubmissionApi';

/** AMMD: list CMDIs that have FCPs with ETTC submissions. */
class ListETTCCmdis extends Component {
    state = {
        loading: true,
        userData: null,
        cmdis: [],
        search: '',
    };

    async componentDidMount() {
        const { data } = await client.query({ query: gql(getUser) });
        const userData = data && data.user;
        this.setState({ userData });

        if (!userData || userData.role !== 'AMMD' || !userData.sfid) {
            this.setState({ loading: false });
            return;
        }

        try {
            const cmdis = await listCmdiForAmmd(userData.sfid);
            this.setState({ cmdis, loading: false });
        } catch (err) {
            this.setState({ loading: false });
            Swal.fire({
                icon: 'error',
                title: 'Load failed',
                text: 'Could not load CMDI list.',
            });
        }
    }

    gotoBack = () => {
        this.props.history.push('/homeAMMD');
    };

    openCmdi = (cmdi) => {
        this.props.history.push({
            pathname: '/ettc-ammd-fcps',
            search: `?cmdiSfid=${encodeURIComponent(cmdi.sfid)}&cmdiName=${encodeURIComponent(
                cmdi.name || ''
            )}&back=${encodeURIComponent('/ettc-ammd-cmdis')}`,
        });
    };

    render() {
        const { loading, cmdis, search } = this.state;
        const term = (search || '').trim().toLowerCase();
        const visible = term
            ? cmdis.filter((cmdi) => (cmdi.name || '').toLowerCase().includes(term))
            : cmdis;

        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.gotoBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit">
                            AMMD — ETTC CMDI List
                        </Typography>
                    </Toolbar>
                </AppBar>

                {loading ? (
                    <Grid container alignItems="center" justify="center" style={{ marginTop: 24 }}>
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <div>
                        <div style={{ padding: 12 }}>
                            <TextField
                                fullWidth
                                placeholder="Search CMDI"
                                value={search}
                                onChange={(e) => this.setState({ search: e.target.value })}
                                margin="none"
                            />
                        </div>
                        <Paper square>
                            {!visible.length ? (
                                <Typography style={{ padding: 16 }}>
                                    {term
                                        ? 'No matching CMDIs found.'
                                        : 'No CMDIs with ETTC submissions.'}
                                </Typography>
                            ) : (
                                visible.map((cmdi) => (
                                    <div key={cmdi.sfid || cmdi.id}>
                                        <List
                                            onClick={() => this.openCmdi(cmdi)}
                                            style={{ cursor: 'pointer', padding: 12 }}
                                        >
                                            <Grid container spacing={8} alignItems="center">
                                                <Grid item xs={7}>
                                                    <Typography variant="body2">
                                                        {cmdi.name}
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        Total: {cmdi.total_submissions || 0}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography align="right" variant="caption">
                                                        Pending: {cmdi.pending_count || 0}
                                                    </Typography>
                                                    <Typography align="right" variant="caption">
                                                        Approved: {cmdi.approved_count || 0}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </List>
                                        <Divider />
                                    </div>
                                ))
                            )}
                        </Paper>
                    </div>
                )}
            </div>
        );
    }
}

export default ListETTCCmdis;
